// Story 6.9 (ADO-1163, AC3) — Button. Figma component 49:409.
//
// Six token-driven variants map to the Figma variant set:
//   primary → "Primary" (success gradient) · secondary → "Secondary Primary"
//   tertiary → "Tertiary Primary" · substitute → "Substitute"
//   destructive → error variant. ("Stock" is an icon+label chip, out of the
//   generic Button surface — modelled by StatusBadge/View Toggle later.)
//
// a11y (NFR24–26): renders a native <button>, keyboard-operable by default,
// with a visible focus ring (Button.module.css :focus-visible). Icon-only usage
// must pass `aria-label`.

import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './Button.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'tertiary' | 'substitute' | 'destructive';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  /** Stretch to the container width (form submit buttons). */
  fullWidth?: boolean;
  /** Optional leading icon (e.g. a design-system icon component). */
  leadingIcon?: ReactNode;
  children?: ReactNode;
}

export function Button({
  variant = 'primary',
  fullWidth = false,
  leadingIcon,
  type = 'button',
  className,
  children,
  ...rest
}: ButtonProps) {
  const classes = [styles.button, styles[variant], fullWidth ? styles.fullWidth : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} {...rest}>
      {leadingIcon}
      {children}
    </button>
  );
}
